/**
 * LPR · item de menu "Lecturas de la camara (LPR)" · helpers PUROS y SIN IMPORTS.
 *
 * 🔴 Este archivo no importa nada, y tiene que seguir asi, por la misma razon que
 * lpr-menu.ts: lo usa BuildingService, que va en el bundle INICIAL del portal. Es un
 * archivo aparte (y no dos funciones mas en lpr-menu.ts) para no tocar el item del reporte
 * "Control vehicular": su spec fija las claves exactas que exporta lpr-menu.ts.
 *
 * El item NO depende de GET lpr/status (que dice si hay una camara ACTIVA DE SALIDA): una
 * camara LPR de entrada, o una que todavia no marca salidas, tambien se puede consultar.
 * Lo decide GET lpr/cameras/:building, con al menos una camara (contrato de lecturas, D5).
 */

/**
 * Lo que respondio GET lpr/cameras para UN sitio, reducido a lo que necesita el menu:
 * `cameras` = la respuesta trae al menos una camara con su `device`. Cualquier otra forma
 * (sin `cameras`, una lista vacia, HTML de un 404) deja el valor en false.
 */
export function lprCamerasSiteStatus(building: any, response: any): { building: any, cameras: boolean } {
    const list = response && Array.isArray(response.cameras) ? response.cameras : [];
    return {
        building: building === undefined ? null : building,
        cameras: list.some(camera => !!camera && typeof camera.device === 'string' && camera.device !== ''),
    };
}

/**
 * ¿Se muestra el item "Lecturas de la camara (LPR)"? Solo si el API dijo que hay camaras
 * para el sitio que esta seleccionado AHORA: lo que se supo de otro sitio no cuenta.
 */
export function lprReadsMenuVisible(status: any, building: any): boolean {
    return !!status && status.cameras === true
        && building !== null && building !== undefined && building !== '' && status.building === building;
}
